module.exports = __webpack_public_path__ + "img/jpeg.dfd4af70.svg";